import { createSlice } from "@reduxjs/toolkit";

const changeLogTableData = {
  onPage: 0,
  pageSize: 0,
  drmMaintenanceDetails: [],
  totalPages: 0,
  totalRecords: 0,
  isLoading: false,
  errorMessage: undefined,
};

const drmChangeLogTableDataSlice = createSlice({
  name: "drmChangeLogTableData",
  initialState: {
    drmChangeLogTableData: changeLogTableData,
    isLoading: false,
    errorMessage: undefined,
  },
  reducers: {
    getDrmChangeLogTableData: (state) => {
      state.isLoading = true;
    },
    setDrmChangeLogTableDataSuccess: (state, action) => {
        state.drmChangeLogTableData = action.payload;
        state.isLoading = false;
    },
    setDrmChangeLogTableDataFailure: (state, action) => {
        state.errorMessage = action.payload;
        state.isLoading = false;
    },
    resetChangeLogTableData: (state) => {
      state.drmChangeLogTableData = {
        onPage: 0,
        pageSize: 0,
        drmMaintenanceDetails: [],
        totalPages: 0,
        totalRecords: 0,
        isLoading: false,
        errorMessage: undefined,
      };
      state.isLoading = false;
      state.errorMessage = undefined;
    },
  },
});

export const {
  getDrmChangeLogTableData,
  setDrmChangeLogTableDataSuccess,
  setDrmChangeLogTableDataFailure,
  resetChangeLogTableData,
} = drmChangeLogTableDataSlice.actions;

export default drmChangeLogTableDataSlice.reducer;
